/**
 * Upgrade Modals Barrel Export
 */

export { default as ExcursionModal } from "./excursion-modal";
export { default as HotelModal } from "./hotel-modal";
export type { ExcursionModalProps } from "./excursion-modal";
export type { HotelModalProps } from "./hotel-modal";
